import React, { useEffect } from 'react';
import './convenios.css';
import { convenios } from '../../json/convenios';

const Convenios = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Convenios</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/assets/pdfs/Convenio_Hidalgo_2025.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Convenio SEBISO-FONART 2025
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/convenios/2024/fonart_2024.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Convenio de Coordinación y Colaboración SEBISO-FONART 2024
            </a>
          </div>
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/convenios/2023/Convenio_FONART_SEBISO_Hgo_2023.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Convenio de Coordinación y Colaboración SEBISO-FONART 2023
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/convenios/2023/Convenio_Fomento.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >Convenio de Colaboración Administrativa en materia de Fomento Artesanal con el municipio de Tenango de Doria 2022
              
            </a>
          </div>
        </div>
      </div>
    </div> 
  );
};

export default Convenios;
